export default __webpack_public_path__ + "static/media/lights.a081d409.gif";